import { NgModule } from '@angular/core';
import { ComponentsModule } from './components/components.module';

const sharedModules = [ComponentsModule];

@NgModule({
  declarations: [],
  imports: [...sharedModules],
  exports: [...sharedModules]
})
export class SharedModule {}
